<template>
    <div class="w-100">
  
        <!-- Aplicar margen -->
        <Button
            :size="15"
            color="#dc3545"
            colorText="#ffffff"
            tooltip="Aplicar Margen Según Filtro"
            icon="fas fa-plus"
            round
            :width="30"
            class="mt-2 mb-3 mr-2"
            @click.native="showModal();"
            translate
        />
        <ui-modal
            ref="modal"
            title="Aplicar Margen Comercial"
            class="modal-editar-simple-acuerdo-linea "
            size="small"
            @close="ActionSetZindexTablaModal(false);ActionSetZindexModal(false);"
        >
    
            <div class="w-100" id="editarMultipleAcuerdoLineasModal">
                <ui-textbox
                    floating-label
                    ref="commercial_margin"
                    label="Margen Comercial"
                    placeholder="Ingrese nuevo valor"
                    v-mask="marginMask"
                    v-model="commercial_margin"
                ></ui-textbox>
            </div>
            <!-- Footer -->
            <div class="d-flex justify-content-between mt-5">
                <button class="btn btn-default" @click="closeModal('modal')">
                    Cerrar
                </button>
                <button class="btn btn-outline-warning" @click="aplicar()" id="buttonRefAplicarMargenComercial">
                    Aplicar
                </button>
            </div>
        </ui-modal>
    </div>
</template>

<script>


import Button from "../../../../common/Button";

import {aplicarMargen} from "../../../../../constants/lineas";
import { mapActions, mapState } from "vuex";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const marginMask = createNumberMask({
    prefix: "",
    suffix: "",
    allowDecimal: true,
    requireDecimal: false,
    includeThousandsSeparator: false,
    decimalSymbol: ".",
    decimalLimit: 2,
    integerLimit: 6,
    allowNegative: true
});

export default {
    props:["data","getListaAcuerdosClientes"],
    data(){
        return {
            marginMask,
            commercial_margin: ""
        }
    },
    computed:{
        ...mapState( ["showAcuerdoClientes"]),

    },
    methods : {
        ...mapActions(["ActionSetZindexModal", 'ActionSetZindexTablaModal']),

        async showModal(){
            if( !this.showAcuerdoClientes ) return this.$vToastify.warning(
                `Se deben filtrar datos para Aplicar Margen Comercial.`,
                "¡Error!"
            );
            
            this.ActionSetZindexModal(true);
            this.ActionSetZindexTablaModal(true);
            this.openModal("modal");
        },
        openModal(ref) {
            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.$refs[ref].close();
        },
        estadoButton(text, estado = true) {
            let buttonRef = document.querySelector("#buttonRefAplicarMargenComercial");
            buttonRef.innerHTML = text;
            buttonRef.disabled = estado;
        },
        async aplicar(){

            if( this.commercial_margin === "" || this.commercial_margin === undefined ){
                this.$refs.commercial_margin.focus() ; 
                return this.$vToastify.warning(
                    `Campo Margen Comercial requerido.`,
                    "¡Error!"
                );
            }

            if( this.data.length === 0  || this.data === undefined ){
                return this.$vToastify.warning(
                    `Deben haber datos para Aplica Margen.`,
                    "¡Error!"
                );
            }

            const form = {
                commercial_margin : parseFloat( this.commercial_margin ) ,
                ids : this.data.map( d => d.data_complementaria.id )
            }
            this.estadoButton("Aplicando...");

            this.$vToastify.loader("Aplicando Margen...");

            try {
                await aplicarMargen( form ) ;
                await this.getListaAcuerdosClientes();

                this.$vToastify.stopLoader();
                this.estadoButton("Aplicar", false);
                this.commercial_margin = "" ;

                this.closeModal('modal');

            } catch (error) {
                this.$vToastify.stopLoader();
                this.estadoButton("Aplicar", false);
                return this.$vToastify.error(
                    `Hubo un problema al actualizar Margen Comercial, intente más tarde.`,
                    "¡Error!"
                );
            }
        }
    },
    components: {
        Button
    }
}
</script>
